<template>
    <b-tabs
        class="apprentice-pills-tab module-access-tab"
        v-if="loaded"
        content-class="module-access-tab-content">
        <b-tab
            :title="$t('modules.groups')"
            active>
            <design-2021-module-management-edit-access-las-component
                :las-groups-in="lasGroupsIn"
                :module-in="module"></design-2021-module-management-edit-access-las-component>
        </b-tab>

        <b-tab :title="$t('modules.main_groups')">
            <design-2021-module-management-edit-access-las-main-component
                :las-main-groups-in="lasMainGroupsIn"
                :module-in="module"></design-2021-module-management-edit-access-las-main-component>
        </b-tab>
    </b-tabs>
</template>

<script>
import { ords } from '../../../app';

const moduleOrds = ords.use('module');

export default {
    name: 'design-2021-module-management-edit-access-component',
    props: {
        lasGroupsIn: Array,
        lasMainGroupsIn: Array,
        moduleIn: Object,
    },
    data() {
        return {
            module: null,
            loaded: false,
            selectedLasGroupIds: [],
        };
    },
    mounted() {
        if (!this.loaded) {
            moduleOrds.add(this.moduleIn);

            moduleOrds
                .with('las_groups')
                .with('las_main_groups')
                .find(this.moduleIn.id)
                .subscribe((module) => {
                    this.module = module;
                });

            this.loaded = true;
        }
    },
};
</script>

<style scoped></style>
